// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___2P3mi","skeleton-loading":"styles__skeleton-loading___3Oi-n","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___24K7D","skeleton-loader-gradient":"styles__skeleton-loader-gradient___1UQZ7","table":"styles__table___b-f7e","header":"styles__header___37aVX","tableHeader":"styles__tableHeader___1N1ey","itemValue":"styles__itemValue___2Wo0L","itemsClasses":"styles__itemsClasses___1PGHx","tableBody":"styles__tableBody___L9zK1","mainSectionSkeleton":"styles__mainSectionSkeleton___1vKwm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ProductsPlantSkeleton/styles.css
// module id = 2514
// module chunks = 0